/**
 * @file monaco-editor 的选项
 * @link <https://microsoft.github.io/monaco-editor/api/interfaces/monaco.editor.ieditorconstructionoptions.html>
 */
export const defaultOptions = {
  // 不显示右侧小地图
  minimap: { enabled: false },
  // 是否允许滚动到最后一行下方
  scrollBeyondLastLine: false,
  // 行号宽度
  // lineNumbersMinChars: 2,
  // 代码折叠
  folding: false,
  // 自动调整窗口大小
  // https://github.com/Microsoft/monaco-editor/issues/28
  // @REMARK: 根据 issue 里面的回复，这个配置项是通过不间断得每 100ms 侦听一次 window.onresize 实现的。为了更
  //          好的性能，之前编写了 `mixins/PiEditorResize.js` 的混入文件。但使用该 mixin 会遇到关闭标签页，
  //          resize 窗口，再次打开标签页编辑器执行 layout() 方法无效的情况，因此不得不再次启用该配置项
  automaticLayout: true
};
